export default __webpack_public_path__ + "static/media/chuter.f5181ea8.jpg";